import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { CreateAccountContainer } from './containers/create-account-container'
import { ForgotAccountContainer } from './containers/forgot-account-container'
import { LoginContainer } from './containers/login-container'
import { ResetPasswordContainer } from './containers/reset-password-container'
import { ActivateContainer } from './containers/activate-container'
import { VerifyEmailContainer } from './containers/verify-email-container/verify-email-container.component'

import { CreateSuccessPageComponent } from './components/create-success-page'
import { ResetAccountSuccessPageComponent } from './components/reset-account-success-page'
import { LogoutContainer } from './containers/logout-container/logout.container'
import { CustomerSelectionContainer } from './containers/customer-selection-container';
import { AuthGuard } from './services/auth-guard-service';
import { LoggedInGuard } from './services/logged-in-guard-service';
import { ResetPasswordSuccessPageComponent } from './components/reset-password-success-page/reset-password-success-page.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginContainer,
    canActivate: [LoggedInGuard]
  },
  {
    path: 'logout',
    component: LogoutContainer
  },
  {
    path: 'create-account',
    component: CreateAccountContainer
  },
  {
    path: 'create-account/success',
    component: CreateSuccessPageComponent
  },
  {
    path: 'verify-email/:userId',
    component: VerifyEmailContainer
  },



  {
    path: 'activate/:token',
    component: ActivateContainer
  },
  {
    path: 'reset-account',
    component: ForgotAccountContainer
  },
  {
    path: 'reset-account/success',
    component: ResetAccountSuccessPageComponent
  },
  {
    path: 'reset-password/success',
    component: ResetPasswordSuccessPageComponent
  },
  {
    path: 'reset-account/:token',
    component: ResetPasswordContainer
  },
  {
    path: 'customer-selection',
    canActivate: [AuthGuard],
    component: CustomerSelectionContainer
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
